import React, { useState, useRef, useEffect, useCallback } from "react";
import { Button, Icon, Table, Card, Image, Loader, Segment } from "semantic-ui-react";
import SharedFunctions from "../../utils/SharedFunctions";
import { LimaInvoiceStatus } from "../../utils/Constants";
import BoxLookupConstants from "../../lib/boxlookup/Constants";
import BoxLookupEndpoints from "../../lib/boxlookup/BoxLookupEndpoints";

export const SortBoxRow = ({
  activeRow,
  box,
  length,
  index,
  setActiveRow,
  onButtonClick,
  workstationID,
  operatorID,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [sortBoxItems, setSortBoxItems] = useState([]);
  const prevActiveRow = usePrevious(activeRow);

  const memoGetBox = useCallback(
    (boxID) => {
      BoxLookupEndpoints.getBox(
        BoxLookupConstants.LookupValueOrigin.Data,
        boxID,
        0,
        workstationID,
        operatorID
      )
        .then((response) => {
          setSortBoxItems(response.sortBoxItems);
        })
        .catch((err) => {
          setError(err);
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [error, workstationID, operatorID]
  );

  useEffect(() => {
    if (index === prevActiveRow && index !== activeRow) {
      setSortBoxItems([]);
    }
    if (index === activeRow && index !== prevActiveRow) {
      setLoading(true);
      memoGetBox(box.boxID);
    }
  }, [activeRow, memoGetBox, prevActiveRow, box.boxID, index]);

  const onRowClick = (index) => {
    if (index === activeRow) {
      return;
    }
    setActiveRow(index);
  };

  const images = () => {
    let items = sortBoxItems;
    if (items.length > 0) {
      items = items.filter((bi) => bi.reservedQuantity > 0);
      items = SharedFunctions.mergeItems("skuID", items);

      const productCards = items.map((item, index) => {
        return (
          <Card key={index}>
            <div className="helper">
              <Image className="leftOverImage" src={item.imageURL} ui={false} />
            </div>
            <Card.Content>
              <Card.Header>SKU: {item.skuID}</Card.Header>
              <Card.Header>Antal: {item.reservedQuantity}</Card.Header>
            </Card.Content>
          </Card>
        );
      });

      return <Card.Group itemsPerRow={5}>{productCards}</Card.Group>;
    }

    return null;
  };
  const invoiceColumn = () => {
    let invoiceColumn = null;

    if (box.invoiceNumber === 0) {
      invoiceColumn = "";
    } else if (box.status === LimaInvoiceStatus.Packadväntande) {
      invoiceColumn = (
        <div>
          <p className="flagImage">
            <Image src={process.env.PUBLIC_URL + "/images/flag_blue.png"}></Image>
          </p>
          <p>{box.invoiceNumber}</p>
        </div>
      );
    } else if (box.status === LimaInvoiceStatus.Skapad) {
      invoiceColumn = (
        <div>
          <p className="flagImage">
            <Image src={process.env.PUBLIC_URL + "/images/flag_yellow.png"}></Image>
          </p>
          <p>{box.invoiceNumber}</p>
        </div>
      );
    } else {
      invoiceColumn = box.invoiceNumber;
    }

    return invoiceColumn;
  };

  const onRowClickWrapper = (index, boxID) => {
    onRowClick(index, boxID);
  };

  const shopAndColumn = (col) => {
    const imageURL = `/images/shop_${box.shopID}_small_logo.png`;
    return (
      <div>
        <p className="shopImage">
          <Image src={process.env.PUBLIC_URL + imageURL}></Image>
        </p>{" "}
        <p> {col}</p>
      </div>
    );
  };

  const row = (invoiceColumn) => {
    return (
      <tr onClick={() => onRowClickWrapper(index, box.boxID)} className="leftoverOrdersRow">
        <Table.Cell className="tableCell">{shopAndColumn(box.boxID)}</Table.Cell>
        <Table.Cell className="tableCell">{getDate(box.printed)}</Table.Cell>
        <Table.Cell className="tableCell">{invoiceColumn}</Table.Cell>
        <Table.Cell className="tableCell">
          {box.invoiceDate === new Date(0) ? "" : getDate(box.invoiceDate)}
        </Table.Cell>
        <Table.Cell className="tableCell">{box.orderNumber}</Table.Cell>
        <Table.Cell className="tableCell">{box.fullCartID}</Table.Cell>
        <Table.Cell className="tableCell">{box.name}</Table.Cell>
        <Table.Cell className="tableCell">{box.sortType}</Table.Cell>
      </tr>
    );
  };

  const imageRow = (invoiceColumn) => {
    return (
      <tr onClick={() => onRowClickWrapper(index, box.boxID)}>
        <Table.Cell className="innerTableContainer" colSpan={8}>
          <Table className="innerTable">
            <Table.Body>
              <Table.Row className="innerRow">
                <Table.Cell className="tableCell">
                  <Button
                    onClick={() => onButtonClick()}
                    className="leftoverButton"
                    icon
                    labelPosition="left"
                  >
                    <Icon name="edit outline"></Icon>
                    Öppna order
                  </Button>
                </Table.Cell>
                <Table.Cell className="tableCell">{getDate(box.printed)}</Table.Cell>
                <Table.Cell className="tableCell">{invoiceColumn}</Table.Cell>
                <Table.Cell className="tableCell">
                  {box.invoiceDate === new Date(0) ? "" : getDate(box.invoiceDate)}
                </Table.Cell>
                <Table.Cell className="tableCell">{shopAndColumn(box.orderNumber)}</Table.Cell>
                <Table.Cell className="tableCell">{box.fullCartID}</Table.Cell>
                <Table.Cell className="tableCell">{box.name}</Table.Cell>
                <Table.Cell className="tableCell">{box.sortType}</Table.Cell>
              </Table.Row>
              {loading ? (
                <Table.Row>
                  <Table.Cell colSpan={8}>
                    <Segment>
                      <div className="loaderTemp">
                        <Loader className="workaround" size="massive">
                          Laddar order
                        </Loader>
                      </div>
                    </Segment>
                  </Table.Cell>
                </Table.Row>
              ) : (
                <Table.Row className="product-row" key={length}>
                  <Table.Cell colSpan={8}>
                    <div className="image-container">{images()}</div>
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </Table.Cell>
      </tr>
    );
  };

  const getDate = (dateTime) => {
    let date = new Date(dateTime);

    return date.toLocaleString("sv-SE");
  };

  let invoice = invoiceColumn();

  if (box.sortBoxID) {
    return null;
  }

  if (index === activeRow && sortBoxItems !== null) {
    return imageRow(invoice);
  }

  return row(invoice);
};
export default SortBoxRow;

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
